import { useState, useEffect, useCallback } from "react";
import Card from "components/Card/Card";
import { useParams } from "react-router-dom";
import {
  useGetFileByIdQuery,
  usePatchFileByIdMutation,
} from "services/file-api.ts";
import { Select } from "components/inputs";
import { useGetRresQuery } from "services/rre-api";
import { Controller, useForm } from "react-hook-form";

export const RRESelection = ({
  isReadOnly = false,
}: { isReadOnly?: boolean } = {}) => {
  const { fileId } = useParams<{ fileId: string }>();
  const [patchFileById] = usePatchFileByIdMutation();
  const [rresList, setRresList] = useState([]);

  const {
    control,
    reset,
    getValues,
    formState: { errors },
  } = useForm();

  const { data: fileData } = useGetFileByIdQuery(
    { id: fileId },
    { skip: !fileId },
  );

  const { data: rres } = useGetRresQuery({}, { skip: false });

  useEffect(() => {
    if (rres) {
      setRresList(
        rres?.results?.map((rre) => ({
          label: rre.name,
          value: rre.id,
        })),
      );
    }
  }, [rres]);

  useEffect(() => {
    if (fileData) {
      reset({
        rre: fileData?.rre || "",
      });
    }
  }, [fileData, reset]);

  const handleSave = useCallback(
    async (api: "rre", field: string, value: string | number | boolean) => {
      await patchFileById({
        id: fileId,
        data: {
          [field]: value,
        },
      });
    },
    [patchFileById, fileId],
  );

  return (
    <Card heading="RRE Selection" cardNumber={1}>
      <Controller
        name="rre"
        control={control}
        render={({ field: { name, onChange, value } }) => {
          return (
            <Select
              name={name}
              onChange={onChange}
              label="RRE"
              errors={errors}
              options={rresList}
              value={rresList.find((option) => option.value === value)}
              readOnly={isReadOnly}
              onBlur={() => {
                if (!isReadOnly) {
                  const option = getValues(name);
                  handleSave("rre", name, option.value);
                }
              }}
            />
          );
        }}
      />
    </Card>
  );
};
